(() => {
  if (window.__senyokoSampleDropdownInitialized) return;
  window.__senyokoSampleDropdownInitialized = true;

  const closeAllDropdowns = (except = null) => {
    document
      .querySelectorAll('.senyoko-sample-dropdown.is-open')
      .forEach((dropdown) => {
        if (dropdown === except) return;

        dropdown.classList.remove('is-open');

        const button = dropdown.querySelector(
          '.senyoko-sample-dropdown__button'
        );

        const menu = dropdown.querySelector(
          '.senyoko-sample-dropdown__menu'
        );

        button?.setAttribute('aria-expanded', 'false');
       
      });
  };

  const syncCustomDropdown = (select, dropdown) => {
    const button = dropdown.querySelector(
      '.senyoko-sample-dropdown__button'
    );

    const menu = dropdown.querySelector(
      '.senyoko-sample-dropdown__menu'
    );

    if (!button || !menu) return;

    const selectedOption =
      select.options[select.selectedIndex];

    button.textContent =
      selectedOption?.textContent?.trim() || '';

    menu
      .querySelectorAll(
        '.senyoko-sample-dropdown__option'
      )
      .forEach((optionButton) => {
        const matchingOption = Array.from(
          select.options
        ).find(
          (option) =>
            String(option.value) ===
            String(optionButton.dataset.value)
        );

        if (!matchingOption) return;

        const isSelected =
          String(matchingOption.value) ===
          String(select.value);

        optionButton.disabled =
          matchingOption.disabled;

        optionButton.classList.toggle(
          'is-disabled',
          matchingOption.disabled
        );

        optionButton.classList.toggle(
          'is-selected',
          isSelected
        );

        optionButton.setAttribute(
          'aria-selected',
          String(isSelected)
        );
      });
  };

  const createCustomDropdown = (select) => {
    if (
      select.dataset.senyokoDropdownInitialized ===
      'true'
    ) {
      return;
    }

    select.dataset.senyokoDropdownInitialized = 'true';
    select.classList.add(
      'complimentary-sample-select--enhanced'
    );

    const dropdown = document.createElement('div');
    dropdown.className = 'senyoko-sample-dropdown';

    const button = document.createElement('button');
    button.type = 'button';
    button.className =
      'senyoko-sample-dropdown__button';

    button.setAttribute('aria-haspopup', 'listbox');
    button.setAttribute('aria-expanded', 'false');

    const menuId = `${select.id}-CustomMenu`;

    button.setAttribute('aria-controls', menuId);

    const menu = document.createElement('div');
    menu.id = menuId;
    menu.className = 'senyoko-sample-dropdown__menu';
    menu.setAttribute('role', 'listbox');
    

    Array.from(select.options).forEach(
      (nativeOption, optionIndex) => {
            if (!nativeOption.value) return;
        const optionButton =
          document.createElement('button');

        optionButton.type = 'button';
        optionButton.className =
          'senyoko-sample-dropdown__option';

        optionButton.dataset.value =
          nativeOption.value;

        optionButton.textContent =
          nativeOption.textContent.trim();

        optionButton.setAttribute(
          'role',
          'option'
        );

        optionButton.setAttribute(
          'aria-selected',
          String(nativeOption.selected)
        );

        optionButton.style.setProperty(
          '--option-index',
          optionIndex
        );

        optionButton.addEventListener(
          'click',
          () => {
            if (optionButton.disabled) return;

            select.value =
              optionButton.dataset.value;

            select.dispatchEvent(
              new Event('change', {
                bubbles: true,
              })
            );

            syncCustomDropdown(
              select,
              dropdown
            );

            /*
             * The existing duplicate-protection code updates
             * disabled options during the same change event.
             * Sync all three custom menus immediately afterward.
             */
            window.requestAnimationFrame(() => {
              document
                .querySelectorAll(
                  '.complimentary-sample-select'
                )
                .forEach((otherSelect) => {
                  const otherDropdown =
                    otherSelect.nextElementSibling;

                  if (
                    otherDropdown?.classList.contains(
                      'senyoko-sample-dropdown'
                    )
                  ) {
                    syncCustomDropdown(
                      otherSelect,
                      otherDropdown
                    );
                  }
                });
            });

            closeAllDropdowns();
            button.focus();
          }
        );

        menu.appendChild(optionButton);
      }
    );

    const desktopHover = window.matchMedia(
  '(min-width: 750px) and (hover: hover) and (pointer: fine)'
);

let hoverCloseTimer;

const openDropdown = () => {
  window.clearTimeout(hoverCloseTimer);

  closeAllDropdowns(dropdown);

  dropdown.classList.add('is-open');
  button.setAttribute('aria-expanded', 'true');
 

  syncCustomDropdown(select, dropdown);
};

const closeDropdown = () => {
  dropdown.classList.remove('is-open');
  button.setAttribute('aria-expanded', 'false');
 
};

const scheduleDropdownClose = () => {
  window.clearTimeout(hoverCloseTimer);

  hoverCloseTimer = window.setTimeout(() => {
    closeDropdown();
  }, 180);
};

/* Desktop mouse interaction */
dropdown.addEventListener('mouseenter', () => {
  if (!desktopHover.matches) return;
  openDropdown();
});

dropdown.addEventListener('mouseleave', () => {
  if (!desktopHover.matches) return;
  scheduleDropdownClose();
});

/* Keep keyboard navigation accessible */
button.addEventListener('click', (event) => {
  if (desktopHover.matches) {
    event.preventDefault();
    return;
  }

  if (dropdown.classList.contains('is-open')) {
    closeDropdown();
  } else {
    openDropdown();
  }
});

    button.addEventListener('keydown', (event) => {
  if (
    event.key === 'ArrowDown' ||
    event.key === 'Enter' ||
    event.key === ' '
  ) {
    event.preventDefault();

    openDropdown();

    const firstAvailableOption =
      menu.querySelector(
        '.senyoko-sample-dropdown__option:not(:disabled)'
      );

    firstAvailableOption?.focus();
  }

  if (event.key === 'Escape') {
    event.preventDefault();
    closeDropdown();
    button.focus();
  }
});

    menu.addEventListener('keydown', (event) => {
      const availableOptions = Array.from(
        menu.querySelectorAll(
          '.senyoko-sample-dropdown__option:not(:disabled)'
        )
      );

      if (!availableOptions.length) return;

      const currentIndex =
        availableOptions.indexOf(
          document.activeElement
        );

      if (event.key === 'ArrowDown') {
        event.preventDefault();

        const nextIndex =
          currentIndex < availableOptions.length - 1
            ? currentIndex + 1
            : 0;

        availableOptions[nextIndex].focus();
      }

      if (event.key === 'ArrowUp') {
        event.preventDefault();

        const previousIndex =
          currentIndex > 0
            ? currentIndex - 1
            : availableOptions.length - 1;

        availableOptions[previousIndex].focus();
      }

      if (event.key === 'Escape') {
        event.preventDefault();
        closeAllDropdowns();
        button.focus();
      }
    });

    dropdown.appendChild(button);
    dropdown.appendChild(menu);

    select.insertAdjacentElement(
      'afterend',
      dropdown
    );

    select.addEventListener('change', () => {
      syncCustomDropdown(select, dropdown);
    });

    syncCustomDropdown(select, dropdown);
  };

  const initializeCustomSampleDropdowns = (
    root = document
  ) => {
    root
      .querySelectorAll(
        '.complimentary-sample-select'
      )
      .forEach(createCustomDropdown);
  };

  document.addEventListener('click', (event) => {
    if (
      !event.target.closest(
        '.senyoko-sample-dropdown'
      )
    ) {
      closeAllDropdowns();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        initializeCustomSampleDropdowns();
      },
      { once: true }
    );
  } else {
    initializeCustomSampleDropdowns();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initializeCustomSampleDropdowns(
        event.target
      );
    }
  );
})(); 